module.exports = __webpack_public_path__ + "static/media/Image@3x.abca8047.png";